import { createFileRoute } from '@tanstack/react-router'

import { PurposesTab } from '@/components/zalo/purposes-tab'

export const Route = createFileRoute(
    '/_app/_authed/_sidebar/settings/zalo/purposes',
)({
    component: PurposesTab,
})
